import React from 'react'
import ResetPassword from './ResetPassword'
import WebService from 'api/explus-api'
import Main from '../../Main'

class ResetPasswordContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
       email: '',
       password: '',
       password_confirmation: '',
       token: this.props.match.params.token
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({child_id: this.props.match.params.childId})
    }
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    let value = target.value;

    this.setState({[name]: value})
  }

  handleSubmit(event) {
    event.preventDefault()
    WebService.ResetPassword(this.state);
    // WebService.ResetPassword(this.state).then(data => {
    //     // window.location.replace("/login");
    //     // console.log('data----------> ', data)
    //  })

  }

  render() {
    return (
      <Main>
        <ResetPassword submit={this.handleSubmit} change={this.handleChange}/>
      </Main>
    )
  }
}

export default ResetPasswordContainer
